import React, { useState, useMemo } from "react";
import PropTypes from "prop-types";
import Select, { components } from "react-select";
import classNames from "classnames";
import { useSolrContext } from "@e-fork/solr";
import useTranslate from "@default/hooks/use-translate";

const SelectFacet = ({ id, label, multiple, isFrontendId }) => {
  const _t = useTranslate();
  const [isOpen, setIsOpen] = useState(false);
  const { facets, setFilter, currentFilters, resetFilter } = useSolrContext();

  const customComponents = useMemo(
    () => ({
      Control: () => null,
      IndicatorsContainer: () => null,
      Option: (props) => (
        <components.Option
          {...props}
          innerProps={{
            ...props.innerProps,
            onClick:
              props.isSelected && !multiple
                ? () => resetFilter(id)
                : props.innerProps.onClick,
          }}
        />
      ),
    }),
    [multiple, id, resetFilter]
  );

  if (!facets || !facets.length) {
    return null;
  }

  const facet = facets.find((facet) => facet.key === id);

  if (!facet) {
    return null;
  }

  const possibleFacets = facet.results;

  const customOptions = possibleFacets.map((term) => ({
    label: isFrontendId ? _t(`overview.facets.${id}.${term.key}`) : term.label,
    value: term.key,
  }));

  const changeHandler = (value) => {
    if (!value?.length && multiple) {
      resetFilter(id);
      return;
    }

    if (multiple) {
      setFilter(
        id,
        value.map((v) => v.value)
      );
    } else {
      setFilter(id, [value.value]);
    }
  };

  const value = multiple
    ? customOptions.filter((option) =>
        currentFilters?.[id]?.includes(option.value)
      )
    : customOptions.find(
        (option) => option.value === currentFilters?.[id]?.[0]
      ) || null;

  const selectedCount = multiple ? value?.length || 0 : value ? 1 : 0;

  return (
    <div className="filters-control-facet-wrapper">
      <button
        type="button"
        className={classNames("facet-accordion-toggle", {
          "is-open": isOpen,
          "has-value": selectedCount > 0,
        })}
        onClick={() => setIsOpen((v) => !v)}
      >
        <span className="facet-accordion-toggle__label text-center">
          {label}
          {selectedCount > 0 && (
          <span className="facet-accordion-toggle__count">
            ({selectedCount})
          </span>
        )}
        </span>
        <div className="icon plus" aria-hidden="true" />
      </button>
      <Select
        options={customOptions}
        isMulti={multiple}
        hideSelectedOptions={false}
        name={id}
        isSearchable={false}
        onChange={changeHandler}
        value={value}
        unstyled={true}
        menuIsOpen={isOpen}
        classNamePrefix="rbf-select"
        components={customComponents}
      />
    </div>
  );
};

SelectFacet.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isFrontendId: PropTypes.bool,
};

export default SelectFacet;
